import script from "./ShortItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShortItem.vue?vue&type=script&setup=true&lang=ts"

import "./ShortItem.vue?vue&type=style&index=0&id=42d1b254&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42d1b254"]])

export default __exports__